<template>
    <div>
        <board-answer-link v-for="component in optionLayouts" :key="`boardComp${component}`" :boardLayout="component" :boardData="boardData" :setData="setData"></board-answer-link>
    </div>
</template>

<script>
    import BoardValidator from "@/mixins/validators/BoardValidator"
    import boardTemplateUtil from "@/components/board/boardTemplateUtil"
    import boardFilterUtil from "@/components/board/boardFilterUtil"
    import BoardAnswerLink from "@/components/board/BoardAnswerLink";
    import VuxAlert from '@/mixins/vux-alert';
    import EventBus from "@/utils/event-bus";
    import util from "@/mixins/util";
    export default {
        name: "BoardAnswerComponent",
        mixins: [boardTemplateUtil, boardFilterUtil, VuxAlert, BoardValidator ],
        components: {
            BoardAnswerLink
        },
        props: {
            boardType: {
                type: String,
                default: '',
            },
            boardKey: {
                default: null,
            }
        },
        data() {
            return{
                optionLayouts: [],
                getCategoryFunc: null,
                getFunc: '',
                createFunc: '',
                updateFunc: '',
                detailApiParamSet: {},
                parsingData: {},
                sendFileType: '',
                createApiParamSet: {},
                answerKeyName: '',
                detailSuccessType:'',

                boardData: {},
                categorys: {
                    list: [],
                    parsing: {},
                },
            }
        },
        beforeRouterEnter() {},
        created() {
            this.initConfig();
        },
        mounted() {
            EventBus.$on('writeAnswer', this.writeAnswer);
        },
        beforeDestroy() {
            EventBus.$off('writeAnswer');
        },
        destroyed() {},
        computed: {
        },
        methods:{
            initConfig() {
                let boardFilterConfig = this.returnBoardFilterConfig(this.boardType);
                this.getCategoryFunc = boardFilterConfig.getCategoryFunc ? boardFilterConfig.getCategoryFunc : null;
                this.getFunc = boardFilterConfig.getFunc;
                this.detailApiParamSet = boardFilterConfig.detailApiParamSet;
                if(this.boardKey != null) {
                    this.id = this.boardKey;
                    this.getInfo();
                }else{
                    this.initTemplateConfig();
                }
                this.createFunc = boardFilterConfig.createFunc;
                this.updateFunc = boardFilterConfig.updateFunc;
                this.parsingData = boardFilterConfig.parsingData;
                this.sendFileType = boardFilterConfig.sendFileType;
                this.createApiParamSet = boardFilterConfig.createApiParamSet;
                this.answerKeyName = boardFilterConfig.answerKeyName;
                this.detailSuccessType = boardFilterConfig.detailSuccessType;
            },
            initTemplateConfig() {
                let boardTemplateConfig = this.returnBoardTemplateConfig(this.boardType);
                this.optionLayouts = boardTemplateConfig.optionLayouts;
            },
            setData(key, value) {
                this[key] = value;
            },
            getInfo() {
                let params = JSON.parse(JSON.stringify(this.detailApiParamSet));
                params.id = Number(this.id);
                try {
                    this.$api.$board[this.getFunc](params).then(res => res.Data.Result).then(res => {
                        if(res.Info.type != this.detailSuccessType) {
                            this.createAlert({
                                title: '',
                                content: '데이터가 없습니다.',
                                btnText: '확인',
                                hide: () => {
                                    this.$router.back();
                                }
                            })
                            return false;
                        }
                        this.boardData = res.List[0];
                        this.initTemplateConfig();
                    })
                }catch (e) {
                    console.log(e);
                }
            },
            writeAnswer() {
                let dataKeys = Object.keys(this.parsingData);
                this.$validate(dataKeys).then((success) => {
                    if(!success) {
                        this.errorAlert('모두 입력해주세요.');
                        return false;
                    }
                    let params = JSON.parse(JSON.stringify(this.createApiParamSet));
                    dataKeys.forEach(dataKey => {
                        params[this.parsingData[dataKey]] = this[dataKey];
                    });
                    let subFunc = this.createFunc;
                    if(!util.isEmpty(this.answerId)) {
                        subFunc = this.updateFunc;
                        params[this.answerKeyName] = this.answerId;
                    }
                    try {
                        this.$api.$board[subFunc](params).then(res => res.Data.Result).then(res => {
                            if(res.Info.type != 1) {
                                this.errorAlert(res.Info.reason);
                                return false;
                            }

                            if(util.isEmpty(this.answerId)) {
                                this.answerId = res.List;
                                if(res.List.hasOwnProperty(this.answerKeyName)) {
                                    this.answerId = res.List[this.answerKeyName];
                                }
                            }
                            this.createAlert({
                                title: '확인',
                                content: '답변이 저장되었습니다.',
                                btnText: '확인',
                                hide: () => {
                                    this.getInfo()
                                }
                            })
                        })
                    }catch (e) {
                        console.log(e);
                    }
                })
            },
        },
        watch: {
        },
    }
</script>

<style scoped>

</style>
